import { List, styled, ScopedCssBaseline } from '@ori-ui/mui';

import { basePositionStyles } from '../../constants';

export const minibagWidthStyle = 'var(--minibag-desktop-width, 400px)';

export const Root = styled('div')<{ ownerState: { breakpointIndex: number; useOpenedMinibagOnDesktop: boolean } }>(
  ({ theme, ownerState }) => ({
    ...basePositionStyles,
    background: theme.palette.background.paper,
    boxShadow: theme.shadows[2],
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    left: 'auto',
    maxWidth: 'calc(100vw - 40px)',
    width: ownerState.useOpenedMinibagOnDesktop && ownerState.breakpointIndex === 2 ? minibagWidthStyle : '400px',
    zIndex: 1,
  }),
);

export const ItemsWrapper = styled(ScopedCssBaseline)(({ theme }) => ({
  position: 'relative',
  display: 'block',
  boxSizing: 'border-box',
  overflow: 'hidden',
  flex: 1,
  background: theme.palette.background.paper,
}));

export const EmptyBag = styled('div')(({ theme }) => ({
  position: 'inherit',
  top: '40%',
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

export const Items = styled(List)<{ ownerState: { isBasketSharingEnabled: boolean | undefined } }>(
  ({ theme, ownerState: { isBasketSharingEnabled } }) => ({
    boxSizing: 'border-box',
    listStyleType: 'none',
    maxHeight: '100%',
    overflow: 'auto',
    paddingTop: theme.spacing(13),
    paddingBottom: theme.spacing(isBasketSharingEnabled ? 26 : 15),
    overscrollBehavior: 'contain',
  }),
);
